module.exports = __webpack_public_path__ + "static/img/ygfc5.e0b3dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/ygfc5.png
// module id = FFIt
// module chunks = 2